import { ErrorSchema } from "@rjsf/utils";

import { Limit } from "../model/Limit";
import { ExtraErrorHelper } from "../helper/ExtraErrorHelper";
import { FormSchemaDto } from "../model/FormSchemaDto";

export async function fetchLimits(endpoint: string): Promise<{ errors?: ErrorSchema; limits?: Limit[] }> {
  const response = await fetch(endpoint);

  if (response.status == 200) {
    const limits = await response.json();
    return {
      limits: limits
    };
  }

  const errorResponse = await response.json();
  const extraErrors = ExtraErrorHelper.toExtraError(errorResponse.message);
  return {
    errors: extraErrors
  };
}

export async function fetchSchema(endpoint: string): Promise<{ errors?: ErrorSchema; schema?: FormSchemaDto }> {
  const response = await fetch(endpoint);

  if (response.status == 200) {
    const schema = await response.json();
    return {
      schema: schema
    };
  }

  const errorResponse = await response.json();
  const extraErrors = ExtraErrorHelper.toExtraError(errorResponse.message);
  return {
    errors: extraErrors
  };
}

export async function postRegistration(endpoint: string, data: any): Promise<{ errors?: ErrorSchema }> {
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      formData: data
    })
  });

  if (response.status === 200) {
    return {};
  }

  const errorResponse = await response.json();
  const extraErrors = ExtraErrorHelper.toExtraError(errorResponse.message);
  return {
    errors: extraErrors
  };
}
